import HeroSection from './HeroSection';
import PrisonChessInitiativeSection from './PrisonChessInitiativeSection';
import MediaCoverageSection from './MediaCoverageSection';
import CommunityOutreachSection from './CommunityOutreachSection';
import RecognitionsTimelineSection from './RecognitionsTimelineSection';
import ImpactMetricsSection from './ImpactMetricsSection';

const SocialImpact = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <HeroSection />
      <ImpactMetricsSection />
      <PrisonChessInitiativeSection />
      <MediaCoverageSection />
      <CommunityOutreachSection />
      <RecognitionsTimelineSection />
    </div>
  );
};

export default SocialImpact;
